import classNames from 'classnames/bind';
import { useReloadTimerContext } from 'contexts/reloadTimer';
import { TripType } from 'contexts/searchParams';
import { Popovers, SelectTypeKeys } from '../types';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const roundTripSelectTypeMap = {
  indivisual: {
    text: '왕복 개별 선택',
    nClickCode: 'isr.selectindividual',
  },
  concurrent: {
    text: '왕복 동시 선택',
    nClickCode: 'isr.selectatonce',
  },
  none: { text: '', nClickCode: '' },
};

const Title = ({
  tripType,
  samePriceOrgSch,
  selectType,
  popover,
  stayLength,
  togglePopover,
  setSelectTypeAndClose,
}: {
  tripType: TripType;
  samePriceOrgSch?: string;
  selectType: SelectTypeKeys;
  popover: Popovers;
  stayLength?: string;
  togglePopover: (popoverKey: Popovers) => void;
  setSelectTypeAndClose: (s: SelectTypeKeys) => void;
}) => {
  const { withReloadTimer } = useReloadTimerContext();

  if (stayLength) return <>가는편 선택</>;
  if (tripType === TripType.OW) return <>편도 선택</>;
  if (tripType === TripType.MD) return <>항공편 선택</>;
  if (samePriceOrgSch) return <>동일가격 다른일정</>;
  return (
    <div className={cx('Title')}>
      <button
        type="button"
        className={cx('current')}
        aria-expanded={popover === Popovers.selectType}
        data-event-nlog="click"
        data-event-area-code="isr.resulttype"
        onClick={() => togglePopover(Popovers.selectType)}
      >
        {roundTripSelectTypeMap[selectType].text}
      </button>
      {popover === Popovers.selectType && (
        <div className={cx('options')}>
          {[SelectTypeKeys.concurrent, SelectTypeKeys.indivisual].map(
            (s, i) => {
              const { text, nClickCode } = roundTripSelectTypeMap[s];
              return (
                <button
                  key={`selectType_${i}`}
                  type="button"
                  className={cx('option')}
                  aria-selected={selectType === s}
                  data-event-nlog="click"
                  data-event-area-code={nClickCode}
                  onClick={withReloadTimer(() => {
                    setSelectTypeAndClose(s);
                  })}
                >
                  <span className={cx('txt')}>{text}</span>
                </button>
              );
            },
          )}
        </div>
      )}
    </div>
  );
};

export default Title;
